import { gql } from '@apollo/client';

export interface GET_REPORTSResponse {
  id: string;
  name: string;
  description?: string;
  sourceType?: string;
  viewType?: string;
  exportType?: string[];
  groups?: { key: string; label: string; condition?: any }[];
  options?: any;
  ownerType: string;
  ownerId?: string;
  locked?: boolean;
}
export const GET_REPORTS = gql`
  query getReports($organisationKey: String!) {
    organisations(key: $organisationKey) {
      id
      reports {
        id
        name
        description
        sourceType
        viewType
        exportType
        groups {
          key
          label
          condition
        }
        options
        ownerType
        ownerId
        locked
      }
    }
  }
`;
